import { render, staticRenderFns } from "./preset-element.vue?vue&type=template&id=2ae1d5d4&"
import script from "./preset-element.vue?vue&type=script&lang=js&"
export * from "./preset-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports